document.addEventListener('click', function(event) {
    if (event.target.matches('.jdgm-new-badge')) {
        // Scroll to the button with aria-label="Reviews"
        var reviewsButton = document.querySelector('button[aria-label="Reviews"]');
        reviewsButton.scrollIntoView({ behavior: 'smooth' });

        // Delay the click on the button to ensure it's scrolled into view
        setTimeout(function() {
            var reviewsButtonText = reviewsButton.querySelector('span').textContent.trim();
            if (reviewsButtonText === "Open Reviews") {
                reviewsButton.click();
            }
        }, 100); // Adjust the delay time as needed
    }
});

document.addEventListener('DOMContentLoaded', function () {
  // Select the target div
  const targetDiv = document.querySelector('div[x-data="ConsciousSkincare.basketNotifications()"]');
  
  if (targetDiv) {
      // Create an <a> element
      const link = document.createElement("a");
      link.href = "/cart"; // Change to your desired link
      link.textContent = "Click Here"; // Change text if needed
      link.style.display = "block"; // Ensure it behaves like a block element if necessary
      link.style.color = "#1f3384"; // Adjust styling as needed
  
      // Append the <a> element inside the div
      targetDiv.appendChild(link);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // Update price on variant change
  document.querySelectorAll('.variant-select').forEach(select => {
    const form = select.closest('form');
    const submitButton = form.querySelector('input[type="submit"]');
  
    // Step 1: Try to select the first enabled option if current one is disabled
    let foundEnabled = false;
    for (let i = 0; i < select.options.length; i++) {
      if (!select.options[i].disabled && select.options[i].value !== "") {
        select.selectedIndex = i;
        foundEnabled = true;
        break;
      }
    }
  
    // Step 2: Disable Add to Basket button if no enabled option found
    if (!foundEnabled) {
      submitButton.disabled = true;
      submitButton.classList.add('opacity-50', 'cursor-not-allowed');
      return; // Stop here since no valid option
    } else {
      submitButton.disabled = false;
      submitButton.classList.remove('opacity-50', 'cursor-not-allowed');
    }
  
    // Step 3: Handle price update on change
    select.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      const price = selectedOption.dataset.price;
      const priceDisplay = this.closest('div').parentElement.querySelector('.price-value');
      if (priceDisplay) priceDisplay.textContent = price;
  
      // Update Add to Basket button state on user selection
      if (selectedOption.disabled) {
        submitButton.disabled = true;
        submitButton.classList.add('opacity-50', 'cursor-not-allowed');
      } else {
        submitButton.disabled = false;
        submitButton.classList.remove('opacity-50', 'cursor-not-allowed');
      }
    });
  
    // Step 4: Trigger change event to set price initially
    select.dispatchEvent(new Event('change'));
  });


  // AJAX Add to Cart
  document.querySelectorAll('form.ajax-add-to-cart').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(data => {
        showBasketNotification();
        // Optionally update cart count in header
        updateCartCount();
      })
      .catch(err => {
        showBasketNotification();
      });
    });
  });

  const offCanvasPanel = document.querySelector('div[x-show="offCanvasState()"]');

  if (!offCanvasPanel) return;

  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('header button');
    
    // Check if the clicked button is the "open" one by checking the <span> inside it
    if (openBtn && openBtn.querySelector('span')?.textContent?.trim() === 'Open main menu') {
      offCanvasPanel.classList.add('show');
    }

    // Check if it's the "close" one
    if (openBtn && openBtn.querySelector('span')?.textContent?.trim() === 'Close menu') {
      offCanvasPanel.classList.remove('show');
      document.querySelector('body').classList.remove('overflow-hidden');
    }
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const count = cart.item_count;
        const countElement = document.querySelector('.headerTop .headerLanguage span.absolute'); // Adjust selector
        const countElementTwo = document.querySelector('header span[x-spread="miniBasketDirectives"]'); // Adjust selector
        if (countElement) {
          countElement.textContent = count;
          countElementTwo.textContent = count;
          document.querySelectorAll('.headerTop .headerLanguage span.absolute').forEach(function(el) {
            el.style.display = 'block';
          });
          document.querySelectorAll('header span[x-spread="miniBasketDirectives"]').forEach(function(el) {
            el.style.display = 'block';
          });
        } 
      });
  }
  
  let basketNotificationTimeout;

  function showBasketNotification() {
    const elements = document.querySelectorAll('div[x-data="ConsciousSkincare.basketNotifications()"]');
  
    elements.forEach(function(el) {
      el.style.display = 'block';
    });
  
    // Clear the previous timeout (if any)
    if (basketNotificationTimeout) {
      clearTimeout(basketNotificationTimeout);
      elements.forEach(function(el) {
        el.style.display = 'none';
      });
      setTimeout(() => {
        elements.forEach(function(el) {
          el.style.display = 'block';
        });
      }, 500);
    }
  
    // Set a new timeout
    basketNotificationTimeout = setTimeout(() => {
      elements.forEach(function(el) {
        el.style.display = 'none';
      });
    }, 5000); // 5 seconds
  }

});
